import { AppState } from '@auth0/auth0-react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import InvalidTokenPage from '../../../components/shared/authentication/InvalidTokenPage';
import { SIGNUP_TOKEN_QUERY } from '../../../data/apollo/queries';

type SignupSearch = {
  preparerCode?: boolean;
};

export const Route = createFileRoute('/_public/signup/$token')({
  component: InvalidTokenPage,
  validateSearch: (search: Record<string, unknown>): SignupSearch => ({
    preparerCode: search?.preparerCode as boolean,
  }),
  beforeLoad: async ({ context: { apolloClient: client }, params, search }) => {
    const { token } = params;
    const { preparerCode } = search;
    let validToken;

    if (token) {
      const appState = {
        returnTo: '/',
      } as AppState;

      const args = { token } as {
        token: string;
        queryString?: string;
      };

      args.queryString = preparerCode ? '?preparerCode=true' : '';

      const { data = {} } = await client.query({
        query: SIGNUP_TOKEN_QUERY,
        variables: args,
        fetchPolicy: 'no-cache',
        context: { skipToken: true },
      });

      validToken = data?.validToken;

      if (validToken?.tokenValid) {
        if (preparerCode) {
          appState.returnTo = `/settings`;
          appState.codeInviteToken = token;
        } else {
          appState.tmpUserToken = token;
        }

        throw redirect({
          to: '/login',
          search: {
            appState,
            authorizationParams: {
              screen_hint: 'signup',
              login_hint: validToken.userEmail,
            },
          },
        });
      }
    }
  },
});
